import React, { Component } from 'react';

import './Header.css';
import InlineSvg from "../InlineSvg";
import customWorksLogo from './../img/custom-works-logo.svg';
import { __ } from './../Translator';


class Header extends Component {
  render() {
    return (
      <div className="header">
        <div className="">
          <div className="col-xs-4">
            <div className="header__pre">
              <h1 className="header__title">{__(this.props.title)}</h1>

              <div className="header__breadcrumb">
                {this.props.breadcrumb.map((text, index) => <span key={index}>{__(text)}</span>)}
              </div>
            </div>
          </div>
          {/*
          todo: Evaluate if this section it's still useful
          In the new html configuration this section it's useless.
          I saved it, just in case we want it back */}
          {/* <div className="col-sm-4 not-display">
            {this.props.heroTitle ? (
              <div className="header__hero">
                <h1 className="hero__title">{this.props.heroTitle}</h1>

                {this.props.heroText ? (
                  <div className="hero__text">{this.props.heroText}</div>
                ) : null}
              </div>
            ) : null}
          </div> */}
          <div className="col-xs-offset-4 col-xs-4 text-right">
            <InlineSvg className="header__logo" svg={customWorksLogo} />
          </div>
        </div>
      </div>
    );
  }
}

Header.defaultProps = {
  breadcrumb: [],
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js